export const getGithubOrganizationData = async (githubUrl, type = 'core') => {
    let gitOrganizationData;
    let error = false;
    try {
        const gitURL = new URL(githubUrl);
        const organization = gitURL.pathname.split('/');
        const repo = organization[2] ? `&repo=${organization[2]}` : '';
        const res = await fetch(`/api/github/organization-data/${organization[1]}?type=${type}${repo}`);
        gitOrganizationData = await res.json();
        return {
            gitOrganizationData,
            error
        }
    } catch (e) {
        gitOrganizationData = false;
        error = true;
        return {
            gitOrganizationData,
            error
        }
    }
}